import { Dispatch } from 'redux';

import { Action } from '../types/action';
import { AppState } from '../types/app-state';
import { Organisation } from '../types/organisation';
import { getOrganisations } from '../services/organisation';
import { loginOrganisation } from '../services/auth';
import { redirectToApp } from '../utils/redirectToApp';
import * as Constants from './organisation.constants';
import * as AuthActions from './auth.actions';

export interface PreselectOrganisationAction extends Action {
  tenantId: string;
}

export interface GetOrganisationsFailedAction extends Action {
  message: string;
}

export interface UpdateOrganisationsAction extends Action {
  organisations: Organisation[];
}

export interface LoginToOrganisationFailedAction extends Action {
  message: string;
}

export function GetOrganisations() {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    try {
      dispatch({ type: Constants.GET_ORGANISATIONS });
      const { token } = getState().auth;
      if (!token) {
        dispatch(AuthActions.InvalidateSession());
        throw new Error('User is not authenticated.');
      }
      const { status, data, message } = await getOrganisations(token);
      if (status === 1 && data && data.organisations) {
        dispatch(GetOrganisationsSuccess());
        const organisations: Organisation[] = data.organisations.map((org) => ({
          id: org.organisation_id,
          name: org.name,
          shardId: org.shard_id,
          tenantId: org.tenant_id
        }));
        dispatch(UpdateOrganisations(organisations));
      } else {
        throw new Error(status === -2 ? message : 'A server error occurred.');
      }
    } catch (error) {
      dispatch(GetOrganisationsFailed(error.message));
    }
  };
}

export function GetOrganisationsSuccess(): Action {
  return {
    type: Constants.GET_ORGANISATIONS_SUCCESS
  };
}

export function GetOrganisationsFailed(message: string): GetOrganisationsFailedAction {
  return {
    type: Constants.GET_ORGANISATIONS_FAILED,
    message
  };
}

export function PreselectOrganisation(tenantId: string): PreselectOrganisationAction {
  return {
    type: Constants.PRESELECT_ORGANISATION,
    tenantId
  };
}

export function UpdateOrganisations(organisations: Organisation[]): UpdateOrganisationsAction {
  return {
    type: Constants.UPDATE_ORGANISATIONS,
    organisations
  };
}

export function LoginToOrganisation(tenantId: string) {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    try {
      dispatch({ type: Constants.LOGIN_TO_ORGANISATION });
      const { token } = getState().auth;
      if (!token) {
        dispatch(AuthActions.InvalidateSession());
        throw new Error('User is not authenticated.');
      }
      const { status, data, message } = await loginOrganisation(token, tenantId);
      if (status === 1 && data && data.sut) {
        redirectToApp(tenantId, data.sut);
      } else {
        throw new Error(status === -2 ? message : 'A server error occurred.');
      }
    } catch (error) {
      dispatch(LoginToOrganisationFailed(error.message));
    }
  };
}

export function LoginToOrganisationFailed(message: string): LoginToOrganisationFailedAction {
  return {
    type: Constants.LOGIN_TO_ORGANISATION_FAILED,
    message
  };
}

export type All
  = Action
  | GetOrganisationsFailedAction
  | UpdateOrganisationsAction
  | LoginToOrganisationFailedAction;